<template>
  <div class="emergency-plan-demo">
    <h2 class="plan-title">{{ planTitle }}</h2>

    <TyphoonRedEmergencyPlan v-if="isTyphoonRedPlan" />
    <PropertyInitialFireEmergencyPlan v-else-if="isPropertyInitialFirePlan" />

    <template v-else>
      <p class="plan-status">正在建设中</p>
    </template>
  </div>
</template>

<script>
import { EMERGENCY_PLAN_CODE_TO_TITLE } from '@/views/layout/emergencyPlansMenu'
import TyphoonRedEmergencyPlan from './TyphoonRedEmergencyPlan.vue'
import PropertyInitialFireEmergencyPlan from './PropertyInitialFireEmergencyPlan.vue'

const TYPHOON_RED_PLAN_CODE = 'natural_typhoon_red'
const PROPERTY_INITIAL_FIRE_PLAN_CODE = 'accident_fire_initial'

export default {
  name: 'EmergencyPlanDemo',
  components: {
    TyphoonRedEmergencyPlan,
    PropertyInitialFireEmergencyPlan
  },
  computed: {
    planTitle() {
      const code = this.$route.query.code
      if (!code) {
        return '应急预案'
      }
      return EMERGENCY_PLAN_CODE_TO_TITLE[code] || '应急预案'
    },
    isTyphoonRedPlan() {
      return this.$route.query.code === TYPHOON_RED_PLAN_CODE
    },
    isPropertyInitialFirePlan() {
      return this.$route.query.code === PROPERTY_INITIAL_FIRE_PLAN_CODE
    }
  }
}
</script>

<style scoped>
.emergency-plan-demo {
  min-height: 200px;
  padding: 24px;
  text-align: left;
  background: #fff;
}

.plan-title {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.plan-status {
  margin: 0;
  font-size: 14px;
  color: #909399;
}
</style>
